module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4wPjl"))).then(() => parcelRequire('d0iPb'));